import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import fetch from '~/common/fetch'
import { BannerApiResponse } from '~/components/v2/SystemAlertBanners'

const getBanners = (): Promise<BannerApiResponse> => fetch.get(`/api/v2/entities/settings/misc/banners/`)

export const useBannersQuery = (opts?: UseQueryOptions<BannerApiResponse>) =>
  useQuery({ queryKey: ['entities', 'settings', 'banners'], queryFn: () => getBanners(), ...opts })
